export const PROFILE_ACTION_TYPES = {
  PROFILE_WISHLIST_SAVE: 'wishlist_save',
  PROFILE_WISHLIST_ADD: 'wishlist_add',
  PROFILE_WISHLIST_REMOVE: 'wishlist_remove',
  PROFILE_WISHLIST_SAVE_ERROR: 'wishlist_save_error',
  PROFILE_WISHLIST_LOADING: 'wishlist_loading'
};

export const addToWishlistAction = ({ offerId, city }) => ({
  type: PROFILE_ACTION_TYPES.PROFILE_WISHLIST_ADD,
  payload: { offerId, city }
});

export const removeFromWishlistAction = ({ offerId, city }) => ({
  type: PROFILE_ACTION_TYPES.PROFILE_WISHLIST_REMOVE,
  payload: { offerId, city }
});

export const setWishlistLoadingAction = isLoading => ({
  type: PROFILE_ACTION_TYPES.PROFILE_WISHLIST_LOADING,
  payload: { isLoading }
});
